import { UnassignedOrderCounts } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The side panel's badge: every open job that is not on the calendar (no day, no time yet, or
 * nobody to do it), unfiltered. It says how much work the garage still has waiting, not how much
 * of it the panel is currently showing.
 *
 * `noDateOnly` for the week and month views, which draw every job that has a day: there the badge
 * is the jobs with no day.
 */
export const useUnAssignedCount = (noDateOnly = false): { counts: UnassignedOrderCounts } => {
  const { orderStore } = useStore();

  useEffect(() => {
    orderStore.getUnAssignedTotals(noDateOnly);
  }, [orderStore, noDateOnly]);

  return { counts: orderStore.unAssignedTotals };
};
